import i18n from '../i18n'

export function secondToHMS (
  totalSeconds,
  hourText = i18n.t('Common.hour'),
  minuteText = i18n.t('Common.minute'),
  secondText = i18n.t('Common.second')
) {
  if (totalSeconds === null) {
    totalSeconds = 0
  }

  let ret = ''

  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds - hours * 3600) / 60)
  let seconds = totalSeconds % 60

  if (hours > 0) {
    seconds = seconds.toFixed(0)
    ret = `${hours} ${hourText} ${minutes} ${minuteText} ${seconds} ${secondText}`
  } else if (minutes > 0) {
    seconds = seconds.toFixed(0)
    ret = `${minutes} ${minuteText} ${seconds} ${secondText}`
  } else {
    seconds = seconds.toFixed(0)
    ret = `${seconds} ${secondText}`
  }

  return ret
}

export function sleep (ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}
